import {
  Content,
  HuseierneBox,
  HuseierneIcon,
  HuseierneOutlinedThemedButton,
} from "./styled";

import { H4 } from "App/global-style";
import React from "react";
import { useIsPartnerBranding } from "Store/partners/partnerHooks";
import { getLocationOrigin } from "Utils/generalUtils";

interface Props {
  headerText: string;
  buttonText: string;
  infoText: string;
  url: string;
}

export const HuseierneMembershipAdvantagesAlert = ({
  headerText,
  buttonText,
  infoText,
  url,
}: Props): React.ReactElement | null => {
  const isPartnerBranding = useIsPartnerBranding();

  if (isPartnerBranding) {
    return null;
  }

  const goToUrl = (): void => {
    window.open(`${getLocationOrigin()}${url}`, "_self");
  };

  return (
    <HuseierneBox>
      <Content>
        <H4>{headerText}</H4>
        <HuseierneOutlinedThemedButton variant="outlined" onClick={goToUrl}>
          {buttonText}
        </HuseierneOutlinedThemedButton>
        <p>{infoText}</p>
      </Content>
      <HuseierneIcon />
    </HuseierneBox>
  );
};
